export const MinusIcon = ({ className }: { className?: string }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M15.8335 9.16797H4.16683C3.70659 9.16797 3.3335 9.54106 3.3335 10.0013C3.3335 10.4615 3.70659 10.8346 4.16683 10.8346H15.8335C16.2937 10.8346 16.6668 10.4615 16.6668 10.0013C16.6668 9.54106 16.2937 9.16797 15.8335 9.16797Z"
      fill="currentColor"
    />
  </svg>
);
